import { put, call, takeLatest, delay } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';

//Action
import { loadingSet } from '../action/uiAction';


function* helpGet(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('type', payload.type);
    params.append('filter', payload.filter);
    return axios.post(config.apiUri + "helpNextApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(100);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "HELP_SET",
        payload: {
          list: res.data.list,
          title: res.data.title,
          categoryChild: res.data.category_child,
          categoryParent: res.data.category_parent,
        },
      });
    }
    else {
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: res.data.comment} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}



const saga = [
  takeLatest('HELP_GET', helpGet),
];

export default saga;
